// Czech for the machine keys of internal/service/duplicates (Reason). A key
// with no label would render as its raw key, so the Go side reads this file
// off disk (TestReasons_EveryKeyHasACzechLabel) and fails when the two lists
// drift apart. The check lives in Go because the frontend image is built
// from frontend/ alone and cannot import the Go source.

export type DuplicateReason =
  | "same_birth_number"
  | "same_name_and_birth_date"
  | "similar_name_same_birth_date"
  | "nickname_same_birth_date"
  | "same_surname_and_birth_date"
  | "same_name_swapped_birth_date"
  | "same_name_close_birth_date"
  | "same_address";

export const DUPLICATE_REASON_LABELS: Record<DuplicateReason, string> = {
  same_birth_number: "Stejné rodné číslo",
  same_name_and_birth_date: "Stejné jméno a datum narození",
  similar_name_same_birth_date: "Podobné jméno, stejné datum narození",
  nickname_same_birth_date: "Domácká podoba jména, stejné datum narození",
  same_surname_and_birth_date: "Stejné příjmení a datum narození (třeba dvojčata)",
  same_name_swapped_birth_date: "Stejné jméno, prohozený den a měsíc narození",
  same_name_close_birth_date: "Stejné jméno, datum narození se liší v jednom údaji",
  same_address: "Stejná adresa",
};

export function duplicateReasonLabel(reason: string): string {
  return DUPLICATE_REASON_LABELS[reason as DuplicateReason] ?? reason;
}
